// extracted by mini-css-extract-plugin
export default {"form-block":"FormBlock_form-block__Ohtxc","form-block__title":"FormBlock_form-block__title__ygXX5"};